jQuery(document).ready(function(){
	
  if( typeof Handlebars !== 'undefined' ){
  	
  	if( typeof giftaid_info !== 'undefined' && typeof jQuery('.giftaid-introduction')[0] !== 'undefined' && jQuery('script.giftaid-introduction-template')[0] !== 'undefined' ){
      	var giftaid_template = Handlebars.compile( jQuery('script.giftaid-introduction-template').html() );
		jQuery('.giftaid-introduction').html(  giftaid_template(giftaid_info) );  
    }
    
  }
  
  function update_messaging_position(){
  		var nspc_2019_main_nav_width = jQuery('.nspc-2019-main-nav').outerWidth();
    	var nav_width = 0;
    	jQuery('.nspc-2019-main-nav ul.nav>li').each(function(){
    		nav_width = nav_width + jQuery(this).outerWidth(); 
        });
    	var nspcc_2019_announcement = jQuery('.nspcc-2019-announcement').outerWidth();
    	if( nspc_2019_main_nav_width > ( nav_width + nspcc_2019_announcement ) ){
    		jQuery('.nspcc-2019-bottom-bar').addClass('float-right');
        }else{
        	jQuery('.nspcc-2019-bottom-bar').removeClass('float-right');
        }
  }
  
  if( typeof jQuery('.nspc-2019-main-nav-desktop')[0] !== 'undefined' ){
  	
    if( typeof jQuery('.nspcc-2019-bottom-bar')[0] !== 'undefined' ){
    	
      update_messaging_position();
      jQuery(window).resize(function(){
      	update_messaging_position();
      });
      
    }
    
  }

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "£{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};  
  
  
  
  function calculate_freq_bought(){
  	var fb_main_container = jQuery('.fb-main-container');
    var fb_totals = {total: 0, item_quantity: 0};
    jQuery(fb_main_container).find('*[name="id"]').each(function(){
      if( typeof fb_totals.item_quantity === 'undefined' ){
      	fb_totals.total = 0;
      }
      if( typeof fb_totals.item_quantity === 'undefined' ){
      	fb_totals.item_quantity = 0;
      }
      
      var fb_prod = jQuery(this).closest('.fb-prod');
      
      var add_to_cart = jQuery(fb_prod).find('*[name="fb-add"]:checked');

      if( typeof jQuery(add_to_cart)[0] === 'undefined' ){
                
      	return;

      }
      
      var current_value = jQuery(this).val();
      
      var current_price = jQuery(this).find('option[value="'+current_value+'"]').data('price');
      
      fb_totals.total = fb_totals.total + current_price;
      fb_totals.item_quantity = fb_totals.item_quantity + 1;
    });
    fb_totals.total_format = Shopify.formatMoney( fb_totals.total );
    var fb_total_content = jQuery( fb_main_container ).find('script.fb-total-content').html();
    if( typeof Handlebars !== 'undefined' && typeof jQuery( fb_main_container ).find('script.fb-total-content')[0] !== 'undefined' ){
          var fbcontent_template = Handlebars.compile( fb_total_content );
          jQuery( fb_main_container ).find('.fb-total-container .total').html( fbcontent_template(fb_totals) );  
    }    
  }
  
  function add_freq_to_cart(){
    
    var cart_data = [];
	var fb_main_container = jQuery('.fb-main-container');
    Shopify.queue = [];
    
    jQuery(fb_main_container).find('*[name="fb-add"]:checked').each(function(){
      var fb_prod = jQuery(this).closest('.fb-prod');
      
      
      var variant_info = jQuery(fb_prod).find('*[name="id"]');
      var current_value = jQuery(variant_info).val();
      
      Shopify.queue.push( {
      
      variantId: current_value,
      quantity: 1
    	
      } );
      
      
    });
    


    Shopify.moveAlong = function() {
      // If we still have requests in the queue, let's process the next one.
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        // pass the properties into addItem as well
        Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
      }
      // If the queue is empty, we will redirect to the cart page.
      else {
        document.location.href = '/cart';
      }
    };    
    
    Shopify.addItem = function(id, qty, properties, callback) {
      var params = {
        quantity: qty,
        id: id
      };
      if(properties != false){
        params.properties = properties;
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function(){
          if(typeof callback === 'function'){
            callback();
          }
        },
        error: function(){}
      });
    }

    Shopify.moveAlong();
  
  }
  
  calculate_freq_bought();
  
  jQuery('body').on('change', '.fb-main-container *[name="id"], .fb-main-container *[name="fb-add"]', function(){
    calculate_freq_bought();
  });
  
  jQuery('body').on('click','.fb-add-to-cart',function(){
  	add_freq_to_cart();
  });
  
  
  jQuery('.color-scheme-box-green, .color-scheme-sub-box-green, .color-scheme-box-white, .color-scheme-sub-box-white').each(function(){
  	var to_do = [];
    if( jQuery(this).hasClass('color-scheme-box-green') || jQuery(this).hasClass('color-scheme-box-white') ){
    	to_do.push( jQuery(this).find('.slide-title') );
    }
    if( jQuery(this).hasClass('color-scheme-sub-box-green') || jQuery(this).hasClass('color-scheme-sub-box-white') ){
    	to_do.push( jQuery(this).find('.caption') );
    }
    jQuery.each(to_do, function(index,td_val){
      if( typeof jQuery().lettering !== 'undefined' ){
    	jQuery(td_val).lettering('lines');
      }
    });
    
  });
  
  
});



jQuery(window).load(function(){
		
  /* jQuery('input[name^="properties"],textarea[name^="properties"]').each(function(){
  	
    if( jQuery(this).prop('readonly') ){
    	return;	
    }
    
    var original = jQuery(this);
    var clone = jQuery(this).clone();
    jQuery(clone).addClass('clone').removeAttr('name');
    jQuery(original).addClass('original').hide();
    var parent = jQuery(original).parent();
    jQuery(parent).addClass('properties-container');
    jQuery(parent).append(clone);
    
    
    var new_element = jQuery(parent).find('.clone');
    
    jQuery(new_element).on('change', function(){
    	var parent = jQuery(this).closest('.properties-container');
      	var original = jQuery(parent).find('.original');
      	var new_val = jQuery(this).val().replace(/"/g, '""');
      	jQuery(original).val( '"' + new_val + '"' );
    });
    
  });
  
  
  jQuery('.prop-val').each(function(){
  	var text = jQuery(this).html();
    text.replace(/(^")|("$)/g, '');
    text.replace(/""/g, '"');
    jQuery(this).html( text.replace(/(^")|("$)g/, "").replace(/""/g,"") );
  });
  */
  
});


if( typeof Handlebars !== 'undefined' ){

  if( typeof jQuery('script.di-content')[0] !== 'undefined' ){
    var di_template = Handlebars.compile( jQuery('script.di-content').html() );
    jQuery('body').on('click', '.delivery-cta', function(){
      console.log( jQuery('<div class="white-popup"></div>') );
      jQuery.magnificPopup.open({
        items: {
          type: 'inline',
          src: jQuery('<div class="white-popup" />').append( di_template() )
        }
      });
    });
    
	 }

}

if( typeof jQuery('.nspcc-shop-tab-content')[0] !== 'undefined' ){
	
  jQuery('body').on('nspccTabSelected', '.nstc-target', function(){
  	var nspcc_shop_tab_content = jQuery(this).closest('.nspcc-shop-tab-content');
    var data_target = jQuery(this).data('target');
    var actual_target = jQuery(nspcc_shop_tab_content).find('.nstc-content[data-target="'+data_target+'"]');
    if( typeof jQuery(actual_target)[0] !== 'undefined') {
    	jQuery(nspcc_shop_tab_content).find('.nstc-content').removeClass('selected');
      	jQuery(nspcc_shop_tab_content).find('.nstc-target').removeClass('selected');
      	jQuery(actual_target).addClass('selected');
      	jQuery(this).addClass('selected');
    }
  });
  
  jQuery('body').on('click', '.nstc-target', function(){
  	jQuery(this).trigger( 'nspccTabSelected' );
  });
  
  jQuery('.nspcc-shop-tab-content').each( function(){
  	jQuery(this).removeClass('non-init').addClass('init');
    jQuery(this).find('.nstc-target').eq(0).trigger( 'nspccTabSelected' );
  });
  
  
  
}

jQuery('body').on('click', '.go-straight-to-checkout', function(){
  if( typeof jQuery('#check-ni')[0] !== 'undefined' ){
  	var cart_checkout = document.getElementsByClassName('cart-checkout')[0].offsetTop;
    window.scrollTo(0, cart_checkout );
  }else{
	jQuery('#checkout').trigger('click');  
  }
});

/*
if( typeof jQuery('#check-ni')[0] !== 'undefined' ){ 
  function checkNI(){
    if( jQuery('#check-ni')[0].checked ){
		jQuery('#checkout').prop('disabled', false );      	
    }else{      
    	jQuery('#checkout').prop('disabled', true );
    }
  }
  checkNI();
  jQuery('body').on('change', '#check-ni', function(){
  	checkNI();
  });
}
*/

jQuery('body').on('click','.add-to-cart', function(){
  
    if( typeof jQuery(this).data('variant-id') === 'undefined' ){
		return false;	
	}

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { quantity: 1,id: jQuery(this).data('variant-id')},
        success: function(){
			document.location.href = '/cart';
        },
        error: function(){
        }
    });
});
